import { Injectable } from '@angular/core';
import { RecipeHit } from './Models/recipe-hit';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  /**
 * Supported cookbooks
 */
  cookbooks = [
    { id: 'NAT', cookbookName: 'Natalie', buttonClass: 'btn-primary' },
    { id: 'RKW', cookbookName: 'Randy', buttonClass: 'btn-rkw' },
    { id: 'JO', cookbookName: 'Awerkamp Family', buttonClass: 'btn-jo' }
  ];


  recipeHits: RecipeHit[] = [];

  currentCookbook = 'NAT';

  constructor() { }

  /**
   * 
   */
  buttonClass() {
    const c = this.cookbooks.find(x => x.id == this.currentCookbook);
    if (!!c) {
      return c.buttonClass;
    }
    return '';
  }


  /**
   * 
   */
  getCookbookName(id: string) {
    return this.cookbooks.find(x => x.id == id).cookbookName;
  }
}
